import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../allcss/blog1.css';
import blogImage from '../Asets/Blog.jpg';
import blog1 from '../Asets/Blog11.png';
import Header from '../components/header';
import Footer from '../components/footer';

const Blog = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="blog-section">
        {/* Hero Section */}
        <div className="blog-hero" style={{ backgroundImage: `url(${blogImage})` }}>
          <div className="blog-overlay">
            <h1 className="blog-title">Our Blog</h1>
            <p className="breadcrumb">
              <span
                style={{ cursor: 'pointer', color: '#fff' }}
                onClick={() => navigate('/')}
              >
                Home
              </span>
              <span> / Our Blog</span>
            </p>
          </div>
        </div>

        {/* Blog Detail */}
        <div className="blog-container">
          <h2 className="section-title">RedSchool House Vadodara – Best Preschool</h2> <br />
          <div className="published-badge">Published on: 25 July 2025</div> <br />

          <img src={blog1} alt="RedSchool House" className="blog-detail-img" />

          <div className="blog-detail-content">
            <p><strong>Welcome to RedSchool House Vadodara: Where Learning Feels Like Play</strong></p>
            <p>Located at A‑25, Castle White, Opposite Harni Water Tank, Harni Sama Link Road, Vadodara, RedSchool House offers a nurturing, playful environment tailored for preschoolers and early learners.</p>

            <p><strong>Why RedSchool House Stands Out in Vadodara</strong></p>
            <ul>
              <li>Play-based, joyful learning: We turn every day into a vibrant discovery journey—through games, stories, and hands-on activities.</li>
              <li>Small class sizes & caring teachers: Personalized attention supports growth academically, socially, and emotionally.</li>
              <li>Values-driven early education: We instill ethics, character-building, and cognitive & socio-emotional development.</li>
            </ul>

            <p><strong>Our Programs & Curriculum</strong></p>
            <ul>
              <li>Holistic early years curriculum: Balancing intellectual, social, physical, creative, and emotional growth.</li>
              <li>Learning through play: Story‑telling, theater, music & movement, art, crafts, and more.</li>
              <li>Character-first foundations: Emphasizing kindness, empathy, and resilience.</li>
            </ul>

            <p><strong>What to Expect at RedSchool House</strong></p>
            <ul>
              <li>Safe, warm, homely environment.</li>
              <li>Qualified early childhood educators.</li>
              <li>On-site enrichment activities like Hip-Hop, Ballet, Piano, Sports.</li>
            </ul>

            <p><strong>Connect With Us Today</strong></p>
            <p>Visit us at A‑25, Castle White, Opp Harni Water Tank, Harni Sama Link Road, Vadodara.</p>
            <p><strong>Call:</strong> +91 77788 51070</p>
            <p><strong>Email:</strong> redschoolhousebaroda@gmail.com </p>

            <p><strong>Why Parents Choose RedSchool House</strong></p>
            <ul>
              <li>Named among top play‑schools in Vadodara.</li>
              <li>Proven early development results.</li>
            </ul>

            <p><strong>RedSchool House Vadodara – Best Play‑Based Preschool Near Harni Sama</strong></p>
            <p>RedSchool House Vadodara blends joyful, small‑class learning with caring guidance. Discover our preschool on Harni Sama Link Road—call +91 77788 51070.</p>

            <p><strong>Call-to-Action:</strong> Schedule a visit, submit inquiries, or book a demo class via phone or website form.</p>

            {/* Go Back Button */}
            <div className="back-to-blogs-btn-wrapper">
              <button
                className="back-to-blogs-btn"
                onClick={() => navigate('/blog')}
              >
                Go Back To Blogs
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Blog;
